import { useState } from 'react';

import { Box, useDisclosure } from '@chakra-ui/react';

import CallHistoryFilters, { CallHistoryFilterValues } from './CallHistoryFilters';
import CallHistoryTable from './CallHistoryTable';
import CallLifecycleDrawer from './CallLifecycleDrawer';
import CallStatsBar from './CallStatsBar';

const thirtyDaysAgo = new Date();
thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
const DEFAULT_DATE_FROM = thirtyDaysAgo.toISOString().split('T')[0];

const DEFAULT_FILTERS: CallHistoryFilterValues = {
  dateFrom: DEFAULT_DATE_FROM,
  dateTo: '',
  agentUserId: '',
  outcome: '',
  flowType: '',
  hasEventType: '',
  callSid: '',
  conferenceId: '',
};

const CallHistoryPage = () => {
  const [filters, setFilters] = useState<CallHistoryFilterValues>(DEFAULT_FILTERS);
  const [selectedConferenceId, setSelectedConferenceId] = useState<string | null>(null);
  const [selectedCallId, setSelectedCallId] = useState<string | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleSelectCall = (conferenceId: string | null, callId: string) => {
    setSelectedConferenceId(conferenceId);
    setSelectedCallId(callId);
    onOpen();
  };

  return (
    <Box p={4}>
      <CallStatsBar filters={filters} />
      <CallHistoryFilters filters={filters} onChange={setFilters} />
      <CallHistoryTable filters={filters} onSelectCall={handleSelectCall} />
      <CallLifecycleDrawer
        isOpen={isOpen}
        onClose={onClose}
        conferenceId={selectedConferenceId}
        callId={selectedCallId}
      />
    </Box>
  );
};

export default CallHistoryPage;
